import {put} from "redux-saga/effects";

import axios from "../../../../../api/axios"

import * as actions from "../../../../actions";
import * as api from "../../../../../api";
import {generateDynamicRoute} from "../../../../../utils/utils";

export function* adminAssignementsUtilisateurCoursSupprimerAssignementUtilisateurCoursSaga (action) {

    yield put(actions.adminAssignementsUtilisateurCoursSupprimerAssignementUtilisateurCoursStart());

    const assignementUtilisateurCoursId = action.payload.assignementUtilisateurCoursId;

    try {
        const response = yield axios.delete(generateDynamicRoute(api.supprimerAssignementUtilisateurCours,[{toReplace:":assignementUtilisateurCoursId",value:assignementUtilisateurCoursId}]));
        yield put(actions.adminAssignementsUtilisateurCoursSupprimerAssignementUtilisateurCoursSuccess(assignementUtilisateurCoursId));
    } catch (error) {
        if(error.response) {
            yield put(actions.adminAssignementsUtilisateurCoursSupprimerAssignementUtilisateurCoursFail(error.response.data.error));
        }else {
            yield put(actions.adminAssignementsUtilisateurCoursSupprimerAssignementUtilisateurCoursFail("There's an error!"));
        }
    }
}

